import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { Arrow, Content } from '@radix-ui/react-popover';

const UnstyledArrow = /*#__PURE__*/forwardRef(function PopoverArrow(props, ref) {
  return createElement(Arrow, {
    className: "pointer-events-none -mt-px",
    asChild: true,
    offset: 2,
    width: 30,
    height: 11
  }, createElement("svg", Object.assign({}, props, {
    ref: ref,
    viewBox: "0 19 30 11",
    style: {
      transform: 'rotateZ(180deg)'
    }
  }), createElement("path", {
    className: "text-grey-dark group-focus:text-blue-light fill-current",
    d: "M23.7,27.1L17,19.9C16.5,19.3,15.8,19,15,19s-1.6,0.3-2.1,0.9l-6.6,7.2C5.3,28.1,3.4,29,2,29h26 C26.7,29,24.6,28.1,23.7,27.1z"
  }), createElement("path", {
    className: "fill-current",
    d: "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z"
  })));
});
const UnstyledContent = /*#__PURE__*/forwardRef(function PopoverContent(props, ref) {
  const {
    placement: side,
    ...otherProps
  } = props;
  const className = cn('border border-transparent rounded p-3 yt-shadow focus:yt-focus outline-none group z-[996]', props.className);
  return createElement(Content, Object.assign({}, otherProps, {
    className: className,
    side: side,
    sideOffset: 1,
    ref: ref
  }));
});

export { UnstyledArrow, UnstyledContent };
//# sourceMappingURL=Primitives.js.map
